import { create } from "zustand";
import {
  AnnouncementListModel,
  AnnouncementModel,
  ClientListModel,
} from "./types";
import { ProductListModel } from "../../products/api/types";

export interface IHomeState {
  initialAnnouncementState: AnnouncementListModel;

  initialClientState: ClientListModel;
  setClientPage: (pageNumber: number) => void;
  initialProductState: ProductListModel;
  setProductPage: (pageNumber: number) => void;
  isLogoutModalOpen: boolean;
  setLogoutModal: (isOpen: boolean) => void;

  previewUrl: string | null;
  previewUrl2: string | null;
  originalFileName: string;
  openCropDialog: boolean;
  setPreviewUrl2: (val: string | null) => void;
  setPreviewUrl: (val: string | null) => void;
  setOpenCropDialog: (val: boolean) => void;
  setOriginalFileName: (val: string) => void;

  isCreateProductModalOpen: boolean;
  setCreateProductModal: (isOpen: boolean) => void;
  isAddModalOpen: boolean;
  setAddModal: (isAddModalOpen: boolean) => void;
  selectedAnnouncement: AnnouncementModel | null;
  setSelectedAnnouncement: (ann: AnnouncementModel | null) => void;
}

const useHomeStore = create<IHomeState>((set) => ({
  selectedAnnouncement: null,
  setSelectedAnnouncement: (ann) => set({ selectedAnnouncement: ann }),
  initialAnnouncementState: {
    items: [],
    totalItem: 0,
    pageNumber: 1,
    pageSize: 10,
    searchText: undefined,
  },
  initialClientState: {
    items: [],
    totalItem: 0,
    pageNumber: 1,
    pageSize: 25,
  },
    initialProductState: {
    items: [],
    totalItem: 0,
    pageNumber: 1,
    pageSize: 10,
    searchText: undefined,
    onlyActive: true,
  },
  isLogoutModalOpen: false,
  setLogoutModal: (isOpen: boolean) =>
    set((state) => ({
      ...state,
      isLogoutModalOpen: isOpen,
    })),

  isCreateProductModalOpen: false,
  setCreateProductModal: (isOpen: boolean) =>
    set((state) => ({
      ...state,
      isCreateProductModalOpen: isOpen,
    })),

  setClientPage: (pageNumber: number) =>
    set((state) => ({
      initialClientState: { ...state.initialClientState, pageNumber },
    })),

  setProductPage: (pageNumber: number) =>
    set((state) => ({
      initialProductState: { ...state.initialProductState, pageNumber },
    })),
  isAddModalOpen: false,
  setAddModal: (isAddModalOpen) => set({ isAddModalOpen }),

  previewUrl: null,
  previewUrl2: null,
  originalFileName: "",
  openCropDialog: false,
  setPreviewUrl2: (previewUrl2: string | null) => set(() => ({ previewUrl2 })),
  setPreviewUrl: (previewUrl: string | null) => set(() => ({ previewUrl })),
  setOpenCropDialog: (openCropDialog: boolean) =>
    set(() => ({ openCropDialog })),
  setOriginalFileName: (originalFileName: string) =>
    set(() => ({ originalFileName })),
}));

export default useHomeStore;
